import React, { useCallback, useEffect, useState } from 'react'
import PubSub from 'pubsub-js'
import FeedbackModal from '../feedback-modal'
import Protal from 'Components/portal'
import useWindowLoaded from 'Components/hooks/use-window-loaded'

export default function ProtalModal() {
  // 反馈 窗口 是否打开
  const [feedbackVisible, setVisible] = useState(false)
  function openFeedback() {
    setVisible(true)
  }
  function closeFeedback() {
    setVisible(false)
  }

  const handler = useCallback((type, value) => {
    openFeedback()
  }, [])

  useEffect(() => {
    const token = PubSub.subscribe('OPEN_FEEDBACK', handler)
    return () => {
      PubSub.unsubscribe(token)
    }
  }, [])

  const isLoaded = useWindowLoaded()

  return (
    <Protal getContainer={() => document.body}>
      {isLoaded ? (
        <FeedbackModal visible={feedbackVisible} onClose={closeFeedback} />
      ) : null}
    </Protal>
  )
}
